import React, { useState } from 'react';
import './CookieBanner.css';

const CookieBanner = ({ onAccept, onReject }) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="cookie-banner-container" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="cookie-banner">
        <div className="cookie-banner-content">
          <h4>AYLA – Cookie Policy</h4>
          <p>
            We use strictly necessary cookies to keep the platform working. Analytics cookies are only enabled if you accept.
            <button
              type="button"
              className="details-toggle"
              onClick={() => setShowDetails(v => !v)}
            >
              {showDetails ? 'Hide' : 'Show'} Details
            </button>
          </p>

          {showDetails && (
            <div className="cookie-policy-details">
              <p><strong>Effective Date:</strong> 22 January 2026</p>
              <p><strong>Jurisdiction:</strong> Italy / European Union</p>
              <p><strong>Platform Status:</strong> Early Access / Beta</p>

              <p>This Cookie Policy explains how AYLA uses cookies and similar technologies on the Platform.</p>

              <h5>1. What Are Cookies</h5>
              <p>
                Cookies are small text files that are stored on your device (computer, smartphone, tablet) when you visit a website.
                Cookies allow websites to function properly, improve user experience, and collect information about how the website is used.
              </p>

              <h5>2. Beta / Early Access Notice</h5>
              <p>
                The Platform is currently provided in an early access (beta) version. As the Platform evolves, the types of cookies used may
                change or be updated. Any material changes will be reflected in this Cookie Policy.
              </p>

              <h5>3. Types of Cookies Used</h5>

              <h6>3.1 Strictly Necessary Cookies</h6>
              <p>
                These cookies are essential for the proper functioning of the Platform and cannot be disabled. They are used to:
              </p>
              <ul>
                <li>Enable basic platform functionality;</li>
                <li>Maintain user sessions;</li>
                <li>Ensure security and authentication.</li>
              </ul>

              <h6>3.2 Analytics Cookies</h6>
              <p>
                Analytics cookies help AYLA understand how users interact with the Platform, such as:
              </p>
              <ul>
                <li>Pages visited;</li>
                <li>Time spent on the Platform;</li>
                <li>General usage patterns.</li>
              </ul>
              <p>
                These cookies are used only to improve the Platform and do not involve profiling. Analytics cookies are activated only after
                the user has given explicit consent via the cookie banner.
              </p>

              <h5>4. Cookie Consent</h5>
              <p>
                When you first visit the Platform, you will see a cookie banner allowing you to:
              </p>
              <ul>
                <li>Accept analytics cookies</li>
                <li>Reject non-essential cookies</li>
              </ul>
              <p>No non-essential cookies are placed without consent.</p>

              <h5>5. Managing Cookies</h5>
              <p>
                Users can manage or delete cookies through their browser settings. Disabling cookies may affect Platform functionality.
              </p>

              <h5>6. Third-Party Cookies</h5>
              <p>
                Some cookies may be placed by third-party service providers (e.g. analytics tools). These providers act in accordance with
                GDPR and applicable privacy laws.
              </p>

              <h5>7. Updates to This Policy</h5>
              <p>
                This Cookie Policy may be updated from time to time. Updates will be published on the Platform.
              </p>
            </div>
          )}
        </div>

        <div className="cookie-banner-actions">
          <button type="button" onClick={onAccept}>Accept</button>
          <button type="button" onClick={onReject}>Reject</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
